import { render, staticRenderFns } from "./ContentWarp.vue?vue&type=template&id=2f7e8a2e&scoped=true"
import script from "./ContentWarp.vue?vue&type=script&lang=js"
export * from "./ContentWarp.vue?vue&type=script&lang=js"
import style0 from "./ContentWarp.vue?vue&type=style&index=0&id=2f7e8a2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e8a2e",
  null
  
)

export default component.exports